import { ClipboardDocumentCheckIcon } from "@heroicons/react/24/outline";
import {
  SectionEmptyState,
  SectionHeader,
  SectionPanel,
} from "../../../componentLibrary/SectionPanel";
import type { ModuleI } from "../../../types";
import { useGetUserToolboxCheckinsByTopic } from "../../../api/queries";
import Tag from "../../../componentLibrary/Tag";
import CheckInRatingChart from "./CheckInRatingChart";

interface Props {
  topic: ModuleI;
}

export default function MyProgressPanel({ topic }: Props) {
  const { data: checkinData } = useGetUserToolboxCheckinsByTopic(topic._id);

  return (
    <SectionPanel className="w-full min-h-48">
      <SectionHeader
        icon={
          <ClipboardDocumentCheckIcon className="w-5 h-5 text-electrum-300 shrink-0" />
        }
        title="My Progress"
      />
      {checkinData && checkinData.items.length > 0 ? (
        <div className="flex flex-col gap-2">
          <div className="flex flex-col gap-0.5">
            {checkinData.items[0].rating !== undefined &&
              checkinData.items[0].ratingScale !== undefined && (
                <div className="flex items-baseline gap-1.5">
                  <span className="text-xs font-medium text-gray-400 uppercase tracking-wide">
                    Latest Check-In:
                  </span>
                  <Tag>
                    {checkinData.items[0].rating}/
                    {checkinData.items[0].ratingScale}
                  </Tag>
                </div>
              )}
            <div className="flex flex-wrap items-center justify-between">
              {checkinData.items[0].createdAt && (
                <span className="text-xs text-gray-400">
                  {new Date(checkinData.items[0].createdAt).toLocaleDateString(
                    undefined,
                    {
                      month: "short",
                      day: "numeric",
                      weekday: "short",
                      year: "numeric",
                    },
                  )}
                </span>
              )}
              <span className="text-xs text-gray-400">
                {checkinData.items.length} check-in
                {checkinData.items.length !== 1 ? "s" : ""} recorded
              </span>
            </div>
          </div>
          <div className="w-full min-h-[240px]">
            <CheckInRatingChart
              checkins={checkinData.items}
              topicColor={topic.color}
              topicTitle={topic.title}
            />
          </div>
        </div>
      ) : (
        <SectionEmptyState>
          <p className="text-sm text-gray-400 py-2">
            Check-ins you complete for {topic.title} will appear here.
          </p>
        </SectionEmptyState>
      )}
    </SectionPanel>
  );
}
